import { createSignal, For } from 'solid-js'
import { cn } from '../../utils/cn.ts'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/Dialog.tsx'
import { GuestAccessPage } from './GuestAccessPage.tsx'
import { UsersPage } from './UsersPage.tsx'

const TABS = [
  ['users', 'Users'],
  ['guest', 'Guest access'],
] as const

export function ManagementDialog(props: { open: boolean, onOpenChange: (open: boolean) => void }) {
  const [tab, setTab] = createSignal<(typeof TABS)[number][0]>('users')

  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent class="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Users and index access</DialogTitle>
        </DialogHeader>

        <div class="flex gap-1 border-b border-border">
          <For each={TABS}>
            {([key, title]) => (
              <button
                type="button"
                class={cn(
                  'cursor-pointer border-b-2 px-2 py-1 text-sm transition-colors',
                  tab() === key ? 'border-primary' : 'border-transparent text-muted-foreground hover:text-foreground',
                )}
                onClick={() => setTab(key)}
              >
                {title}
              </button>
            )}
          </For>
        </div>

        <div class="max-h-[60vh] overflow-y-auto">
          {tab() === 'users' ? <UsersPage /> : <GuestAccessPage />}
        </div>
      </DialogContent>
    </Dialog>
  )
}
